import { getThemeProps } from "@material-ui/styles";
import React, { useState, useEffect } from "react";
import { Tab, Nav, Button, Table, Form } from "react-bootstrap";
import CustomSwitch from "utils/CustomSwitch";
import UserSelector from "utils/UserSelector";

export default function PpcSupportingRoles(props) {
	const serviceName = props.service[0].toUpperCase() + props.service.slice(1);
	let service = props.service;
	if (props.service == "ppc") service = "search";
	const accountLeads = props[`${service}_section`].account_leads;
	const accountSupports = props[`${service}_section`].account_supports;
	return (
		<>
			<div className={`p-3 mb-3 ppc-supporting-roles ${props.service}`} style={{ backgroundColor: "#e1e1e1" }}>
				<p className="mb-2 text-info service-name">{serviceName} Team</p>
				<p className="mb-1">Account Lead(s)</p>
				<UserSelector validator={props.validator} defaultValue={accountLeads} modalHeader={`${props.client_company.company_name} - Select ${serviceName} Account Leads`} users={props.users} fieldsForArray={["supporting_roles", props.service, "account_leads"]} isEnabled={props.isEnabled} setServiceAccount={props.setServiceAccountLeads} />
				<p className="mb-1">Account Support</p>
				<UserSelector
				  validator={props.validator}
					defaultValue={accountSupports}
					modalHeader={`${props.client_company.company_name} - Select ${serviceName} Account Supports`}
					users={props.users}
					fieldsForArray={["supporting_roles", props.service, "account_support"]}
					isEnabled={props.isEnabled}
					setServiceAccount={props.setServiceAccountSupports}
				/>
			</div>
		</>
	);
}
